import { useDataFetch } from '../../../hooks/use-data-fetch';

export interface CountryPaymentInfo {
  country_id: string;
  name: string;
  paymentGateways: string[];
  currency: string;
  pointValue: number;
  status: boolean;
  created_at: string;
  createdAt: string;
  updatedAt: string;
  id: string;
}

export interface CountryPaymentResponse {
  status: number;
  country: CountryPaymentInfo;
  message: string;
  errors: null | any;
}

/**
 * Hook personalizado para obtener los métodos de pago disponibles para el usuario
 * @returns Objeto con los datos de los métodos de pago y el estado de la consulta
 */
export const usePaymentMethods = () => {
  const { getData } = useDataFetch();
  
  // Utilizamos el hook useGetData para hacer la petición GET al endpoint
  const query = getData(
    ['paymentMethods'],
    '/product/countries-available/by-user',
    {
      // Opciones adicionales de la consulta
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutos
      gcTime: 1000 * 60 * 10 // 10 minutos (anteriormente cacheTime)
    }
  );

  // Extraer los métodos de pago disponibles de la respuesta
  const paymentGateways = query.data?.country?.paymentGateways || [];
  const countryInfo = query.data?.country || null;
  
  return {
    paymentGateways,
    countryInfo,
    ...query
  };
};
